module.exports = __webpack_public_path__ + "img/BOR_bistro.dcb0c60e.webp";